module.exports = __webpack_public_path__ + "img/index_photowall_banner.25b8c0c0.png";